import * as moment from "moment";
import JobAgentChangeNotificationData from "./JobAgentChangeNotificationData";
import NotificationBase from "../../NotificationBase";
import {JobAgentChangeNotificationDataApiDto, NotificationBaseApiDto} from "../../../../api/model/rest";
import {getUser} from "../../../../store/view/user";

/**
 * Agent changed notification.
 */
export default class JobAgentChangeNotification extends NotificationBase {
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: JobAgentChangeNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): JobAgentChangeNotification {
		return new JobAgentChangeNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			JobAgentChangeNotificationData.fromJson(json.data as JobAgentChangeNotificationDataApiDto));
	}

	/**
	 * Display user Full name.
	 */
	displayCreatorName(): string {
		return getUser(this.data.entity.id).map(u => u.getDisplayName()).getOrElse(this.data.entity.id);
	}

	/**
	 * Display previous agent full name
	 */
	displayPreviousAssignee(): string {
		return this.data.previousAgentId
			.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("Unassigned"))
			.getOrElse("Unassigned");
	}

	/**
	 * Display current agent full name
	 */
	displayCurrentAssignee(): string {
		return this.data.currentAgentId
			.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("Unassigned"))
			.getOrElse("Unassigned");
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new JobAgentChangeNotification(id, dateTime, read, type, data);
	}
}